
import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import { namespace, Getter, Action, Mutation } from "vuex-class";

import Sessions from "@/components/Sessions.vue";
import Cameras from "@/components/Cameras.vue";
import LinkingCamera from "@/components/LinkingCamera.vue";
import ManualRaise from "@/components/ManualRaise.vue";
import ProcessingError from "@/components/ProcessingError.vue";

import { MatrixState } from "@/store/types";
import { EventDetails } from "@/store/site-monitor/types";
import { MessageBroadcastChannel } from "@/utils/messageBroadcastChannel";

const SiteMonitor = namespace("siteMonitor");
const SMCameras = namespace("siteMonitorCameras");
const EventQueue = namespace("eventqueue");

@Component({
	components: {
		cameras: Cameras,
		session: Sessions,
		"link-camera": LinkingCamera,
		"manual-raise": ManualRaise,
		"processing-error": ProcessingError
	}
})
export default class SiteMonitorCameras extends Vue {
	@Getter private isLoggedIn: boolean;
	@Getter private getFeature: (featureNames: string[]) => boolean;
	@Mutation private setMediaMatrixState: (state: MatrixState) => void;

	@SiteMonitor.Getter("getEventDetails") private eventDetails: EventDetails;

	@Provide("matrixChannel")
	private mediaMatrixChannel: MessageBroadcastChannel = new MessageBroadcastChannel("matrix");

	public get eventId() {
		return this.eventDetails?.eventID ?? 0;
	}

	public get mediaMatrixEnabled() {
		return this.getFeature(["Alarms", "MediaMatrix"]);
	}

	public get linkedCamerasEnabled() {
		return this.getFeature(["Alarms", "MediaMatrix", "LinkedCameras"]);
	}

	public created() {
		// Ensure that if the window is closed, we update the matrix state
		window.onbeforeunload = () => {
			this.setMediaMatrixState(MatrixState.closed);
		};
	}

	public async destroyed() {
		await this.setMediaMatrixState(MatrixState.closed);
	}

	@Watch("isLoggedIn")
	private onIsLoggedInChanged(value: boolean) {
		if (!value) {
			window.close();
		}
	}
}
